import { render, staticRenderFns } from "./Expenses.vue?vue&type=template&id=3d4905c3"
import script from "./Expenses.vue?vue&type=script&lang=js"
export * from "./Expenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports